import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
    selector: 'elight-progress-button',
    templateUrl: './progress-button.component.html',
    styleUrls: ['./progress-button.component.scss'],
})
export class ProgressButtonComponent {
    @Input() type: string;
    @Input() mdType:
        | 'raised'
        | 'flat'
        | 'basic'
        | 'stroked'
        | 'icon'
        | 'fab'
        | 'mini-fab';
    @Input() color: ThemePalette;
    @Input() inProgress: boolean;
    @Input() diameter = 18;
    @Input() disabled = false;
    @Input() visible = true;

    @Output() clicked = new EventEmitter();

    public onClick() {
        if (this.disabled) {
            return;
        }
        this.clicked.emit();
    }
}
